import { i18n } from "../main";
import lodash from "lodash";
import cacheService from "@/services/cache";
import moment from "moment";

const d3 = require("d3");

export default {
    brandId: cacheService.getCurrentBrandId(),
    zoneId: cacheService.getCurrentZoneId(),
    campaignId: 1,
    siteUrl: process.env.BASE_URL,
    prefixUrl: location.protocol + "//",
    suffixUrl: process.env.SUFFIX_URL,
    suffixBackHost: process.env.SUFFIX_BACK_HOST,
    suffixFrontHost: process.env.SUFFIX_URL,
    rem3rchVersion: process.env.REM3RCH_VERSION,

    CurrencyCustomPipe(value, codeIso = "fr-FR", currency = "EUR") {
        return value.toLocaleString(codeIso, {
            style: "currency",
            currency: currency
        });
    },
    getApiUrl() {
        return this.siteUrl;
    },
    getBaseUrl() {
        return this.prefixUrl + this.suffixUrl;
    },
    getBackHost() {
        return this.prefixUrl + this.suffixBackHost;
    },
    nav: null,
    NAVIGATOR_UNKNOWN: 0,
    NAVIGATOR_IE: 1,
    NAVIGATOR_SAFARI: 2,
    NAVIGATOR_OPERA: 3,
    NAVIGATOR_MOZILLA: 4,
    NAVIGATOR_CHROME: 5,
    getNavigator() {
        let NAVIGATOR_UNKNOWN = this.NAVIGATOR_UNKNOWN;
        let NAVIGATOR_IE = this.NAVIGATOR_IE;
        let NAVIGATOR_SAFARI = this.NAVIGATOR_SAFARI;
        let NAVIGATOR_OPERA = this.NAVIGATOR_OPERA;
        let NAVIGATOR_MOZILLA = this.NAVIGATOR_MOZILLA;
        let NAVIGATOR_CHROME = this.NAVIGATOR_CHROME;
        let n = this.nav;
        if (n === null) {
            if (window.opera) {
                n = NAVIGATOR_OPERA;
            } else if (window.navigator && navigator.vendor && navigator.vendor.indexOf("Apple") !== -1) {
                n = NAVIGATOR_SAFARI;
            } else if (window.navigator && navigator.vendor && navigator.vendor.indexOf("Google") !== -1) {
                n = NAVIGATOR_CHROME;
            } else if (document.documentMode) {
                n = NAVIGATOR_IE;
            } else if (window.navigator && navigator.product === "Gecko") {
                n = NAVIGATOR_MOZILLA;
            } else {
                n = NAVIGATOR_UNKNOWN;
            }
        }

        return (this.nav = n);
    },
    isMobile(mobile = "any") {
        let Mobile = {
            android() {
                return navigator.userAgent.match(/Android/i);
            },
            blackBerry() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS() {
                return navigator.userAgent.match(/iPhone/i);
            },
            opera() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            windows() {
                return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
            },
            any() {
                return Mobile.android() || Mobile.blackBerry() || Mobile.iOS() || Mobile.opera() || Mobile.windows();
            }
        };
        let isMobile = false;
        switch (mobile) {
            case "any":
                isMobile = Mobile.any() !== null;
                break;
            case "blackBerry":
                isMobile = Mobile.blackBerry() !== null;
                break;
            case "iOS":
                isMobile = Mobile.blackBerry() !== null;
                break;
            case "windows":
                isMobile = Mobile.windows() !== null;
                break;
            case "opera":
                isMobile = Mobile.opera() !== null;
                break;
            case "android":
                isMobile = Mobile.android() !== null;
                break;
            default:
                isMobile = Mobile.any() !== null;
                break;
        }

        return isMobile;
    },
    getTranslate(translate, locale = null) {
        locale = i18n.locale;
        if (!translate) return "";
        let trans = translate[locale] ? translate[locale] : translate["en"];
        if (trans) {
            try {
                let value = trans.value;
                let val = value === undefined || value === null ? trans : value;
                return val === undefined || val === null ? "" : val;
            } catch (e) {
                console.error("Error Not text, getTranslate globals.js");
                return "";
            }
        } else {
            return "";
        }
    },
    /**
     * Transform date GTM
     * @param date
     * @returns {string}
     */
    transformDateToGmt(date) {
        return (
            date.getUTCFullYear() +
            "-" +
            (date.getUTCMonth() + 1) +
            "-" +
            date.getUTCDate() +
            " " +
            date.getUTCHours() +
            ":" +
            (date.getUTCMinutes() < 10 ? "0" + date.getUTCMinutes() : date.getUTCMinutes()) +
            ":00"
        );
    },
    /**
     * Convert Date GTM to Local
     * @param dateGmt
     * @returns {Date}
     */
    convertGmtToLocal(dateGmt) {
        let newDate = new Date(dateGmt.getTime() + dateGmt.getTimezoneOffset() * 60000);

        let offset = dateGmt.getTimezoneOffset() / 60;
        let hours = dateGmt.getHours();

        newDate.setHours(hours - offset);

        return newDate;
    },

    getValueObject(obj, path, valueDefault = null) {
        let properties = path.split(".");
        let valueTmp = obj;
        let value;
        let prop;
        let valid = true;
        for (let i = 0, l = properties.length; i < l; i++) {
            prop = properties[i];
            valueTmp = valueTmp[prop];
            if (i !== l - 1) {
                if (valueTmp === undefined || valueTmp === null) {
                    valid = false;
                    break;
                }
            } else {
                if (valueTmp === undefined) {
                    valid = false;
                    break;
                }
            }
        }

        if (valid === false) value = valueDefault;
        else value = valueTmp;

        return value;
    },
    confNavigatorCompatibles() {
        // @info: add here obj with info compatible navigators
        let output = [{ name: "Chrome", id: 5 }];

        return output;
    },
    isCompatibleNavigator() {
        let output = false;
        let isCompatibleNavigator;
        let idNavigator = this.getNavigator();
        let listIdCompatiblesNavigator = this.confNavigatorCompatibles().map(curr => {
            return curr.id;
        });

        isCompatibleNavigator = listIdCompatiblesNavigator.includes(idNavigator);
        output = isCompatibleNavigator;

        return output;
    },

    /**
     * @description return true si l'Observer est un array
     */
    isArray(observer) {
        /* eslint-disable */
        if (observer) {
            return observer.__proto__ instanceof Array;
        }

        return false;
        /* eslint-enable */
    },

    UUID() {
        let s = [];
        let itoh = "0123456789ABCDEF";
        for (let i = 0; i < 36; i++) {
            s[i] = Math.floor(Math.random() * 0x10);
        }

        s[14] = 4;
        s[19] = (s[19] & 0x3) | 0x8;

        for (let j = 0; j < 36; j++) {
            s[j] = itoh[s[j]];
        }

        s[8] = s[13] = s[18] = s[23] = "-";
        return s.join("");
    },

    sleep(time) {
        return new Promise(resolve => setTimeout(resolve, time));
    },

    loadSvg(url) {
        let promise = new Promise((resolve, reject) => {
            d3.xml(url)
                .mimeType("image/svg+xml")
                .get((error, xml) => {
                    if (error) {
                        console.error(error, url);
                        reject(null);
                    } else {
                        resolve(xml.documentElement);
                    }
                });
            // } else {
            //     // let xmlns = 'http://www.w3.org/2000/svg'
            //     //
            //     // var svgElem = document.createElementNS(xmlns, 'svg')
            //     // svgElem.outerHTML = svg
            //     // resolve(svgElem)
            // }
        });

        return promise;
    },

    stepArray(start, end, step) {
        let ar = [];
        // ar.push(start)
        let len = Math.floor(end / step);
        let res = 0;
        for (let i = 0; i < len; i++) {
            res += step;
            ar.push(res);
        }
        return ar;
    },

    assign(obj) {
        return lodash.cloneDeep(obj);
    },
    /**
     *
     * @param status
     * @param data
     */
    addCheckedStar(status, data) {
        connectionBO.putStar(status, data).then(response => {});
    },

    async urlToBase64(url, type = "png") {
        function arrayBufferToBase64(buffer) {
            let binary = "";
            let bytes = [].slice.call(new Uint8Array(buffer));

            bytes.forEach(b => {
                binary += String.fromCharCode(b);
            });

            return window.btoa(binary);
        }

        let res = await fetch(url, {
            method: "GET"
        });

        let buffer = await res.arrayBuffer();
        let base64Flag = `data:image/${type};base64,`;
        let imageStr = arrayBufferToBase64(buffer);
        let base64 = base64Flag + imageStr;
        return base64;
    },
    /**
     *
     */
    flushLocalStorageDatas() {
        cacheService.set("currentStandId", null);
        cacheService.set("currentZoneId", null);
        cacheService.set("currentCampaignId", null);
    },
    updatePreferences(data, noRefresh = false) {
        connectionBO.getPreferences().then(v => {
            let prefRegistre = v;
            let isBrand = parseInt(prefRegistre.preference.brand.id) === parseInt(cacheService.getCurrentBrandId());
            let zonesUpdate = false;
            let standCompUpdate = false;

            if (prefRegistre.preference.brand.default && data === "brand") {
                prefRegistre.preference.brand.id = cacheService.getCurrentBrandId();
                prefRegistre.preference.zone.id = cacheService.getCurrentZoneId();
                prefRegistre.preference.stand.id = cacheService.getCurrentStandId();
                prefRegistre.preference.campaign.id = cacheService.getCurrentCampaignId();
            }
            if (prefRegistre.preference.zone.default && isBrand && data === "zones") {
                if (prefRegistre.preference.campaign.default && isBrand) {
                    if (prefRegistre.preference.stand.default && isBrand) {
                        prefRegistre.preference.stand.id = cacheService.getCurrentStandId();
                        prefRegistre.preference.campaign.id = cacheService.getCurrentCampaignId();
                    } else {
                        prefRegistre.preference.campaign.id = cacheService.getCurrentCampaignId();
                    }
                }
                prefRegistre.preference.zone.id = cacheService.getCurrentZoneId();
                zonesUpdate = true;
            }
            if (prefRegistre.preference.campaign.default && isBrand && data === "campaigns") {
                if (prefRegistre.preference.stand.default && isBrand) {
                    prefRegistre.preference.stand.id = cacheService.getCurrentStandId();
                    prefRegistre.preference.campaign.id = cacheService.getCurrentCampaignId();
                } else {
                    prefRegistre.preference.campaign.id = cacheService.getCurrentCampaignId();
                }
                standCompUpdate = true;
            }

            /**
             * UPDATE Preference
             */
            if (typeof prefRegistre.preference !== "undefined") {
                connectionBO.putPreference(prefRegistre);

                if (noRefresh) return;

                let url = "/";
                let targetUrl = false;
                if (sessionStorage.getItem("targetUrl")) {
                    targetUrl = true;
                    url = sessionStorage.getItem("targetUrl");
                    sessionStorage.removeItem("targetUrl");
                }

                if (data === "brand") {
                    window.location.replace(url);
                } else if (zonesUpdate || standCompUpdate) {
                    targetUrl ? window.location.replace(url) : window.location.reload();
                } else if ((!isBrand && data !== "brand") || !prefRegistre.preference.zone.default || !prefRegistre.preference.campaign.default) {
                    targetUrl ? window.location.replace(url) : window.location.reload();
                }
            }
        });
    },
    // moment.js library to handle dates + times in JS, see https://momentjs.com/
    moment(...args) {
        return moment.apply(undefined, args);
    }
};



// WEBPACK FOOTER //
// ./src/components/globals.js